import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { Fade } from "react-awesome-reveal";
import { Link, useSearchParams } from "react-router-dom";
import {
  baseUrl,
  useFindJobByCategoryApiQuery,
  useFindJobByZipCodeApiQuery,
} from "../../../services/apiSlice";
import Swal from "sweetalert2";
import Loading from "../../Loading";
import { Container } from "@mui/system";
import TransitionsModal from "../../modal/viewJob";

import { GetJobSearchResult } from "./GetJobSearchResult";

// const GetJobSearchResult = ({ AllResult, zipCodeResult }) => {
//   console.log({ AllResult });

//   return (
//     <>
//       <Fade cascade>
//         <Grid
//           container
//           item
//           spacing={{ xs: 2, md: 4, my: 10 }}
//           // columns={{ xs: 4, sm: 8, md: 12 }}
//           width="100%"
//           sx={{ width: "100%" }}
//         >
//           {AllResult?.length === 0
//             ? AllResult?.map((v, i) => (
//                 <>
//                   <Grid
//                     key={v._id}
//                     className="w-full"
//                     sx={[
//                       { px: 3 },
//                       (theme) => ({
//                         [theme.breakpoints.down("sm")]: {
//                           width: "90%",
//                           py: 3,
//                           mx: 3,
//                         },
//                       }),
//                     ]}
//                   >
//                     <Card sx={{ maxWidth: "100%" }}>
//                       {/* {v.files?.map(
//                     (file) => (
//                       console.log({ file }),
//                       (
//                         <CardMedia
//                           component="img"
//                           height="140"
//                           image={`${baseUrl + `upload/` + file?.path}`}

//                           alt="green iguana"
//                           // src={`${
//                           //   baseUrl +
//                           //   `upload/` +
//                           //   confirmPayment?.confirmPayment?.files?.path
//                           // }`}
//                         />
//                       )
//                     )
//                   )} */}
//                       <CardMedia
//                         component="img"
//                         height="140"
//                         image={`${baseUrl + `upload/` + v?.files[0]?.path}`}
//                         alt="green iguana"
//                         // src={`${
//                         //   baseUrl +
//                         //   `upload/` +
//                         //   confirmPayment?.confirmPayment?.files?.path
//                         // }`}
//                       />
//                       <CardContent>
//                         <Typography
//                           sx={{
//                             color: "black",

//                             textTransform: "capitalize",
//                           }}
//                           gutterBottom
//                           variant="h5"
//                           component="div"
//                         >
//                           {v?.categories}
//                         </Typography>
//                         <Typography
//                           sx={{
//                             color: "black",
//                             fontSize: 16,
//                             textTransform: "capitalize",
//                           }}
//                           variant="body2"
//                           color="text.secondary"
//                         >
//                           {v?.job_description}
//                         </Typography>{" "}
//                         <Typography
//                           variant="body2"
//                           sx={{ py: 2 }}
//                           color="text.secondary"
//                         >
//                           Date Posted:{" "}
//                           <Typography
//                             sx={{
//                               color: "black",
//                             }}
//                             variant="span"
//                           >
//                             {v?.dateCreated}
//                           </Typography>
//                         </Typography>{" "}
//                         <Typography variant="body2" color="text.secondary">
//                           posted By:
//                           <Typography
//                             sx={{
//                               color: "black",
//                               fontSize: 20,
//                               textTransform: "capitalize",
//                             }}
//                             variant="span"
//                           >
//                             {/* {zipCodeResult?.dateCreated} */} {"babat"}
//                           </Typography>
//                         </Typography>
//                       </CardContent>
//                       <CardActions>
//                         <Button size="small">Share</Button>
//                         <Button size="small">Learn More</Button>
//                       </CardActions>
//                     </Card>{" "}
//                     {/* <Item>3</Item> */}
//                   </Grid>
//                   <Grid
//                     key={v._id}
//                     className="lg:w-[30%] md:pb-5 md:w-[40%]  sm:w-2/4"
//                     sx={[
//                       { px: 2 },
//                       (theme) => ({
//                         [theme.breakpoints.down("sm")]: {
//                           width: "90%",
//                           py: 3,
//                           mx: 3,
//                         },
//                       }),
//                     ]}
//                   >
//                     <Card sx={{ width: "100%" }}>
//                       {/* {v.files?.map(
//                     (file) => (
//                       console.log({ file }),
//                       (
//                         <CardMedia
//                           component="img"
//                           height="140"
//                           image={`${baseUrl + `upload/` + file?.path}`}

//                           alt="green iguana"
//                           // src={`${
//                           //   baseUrl +
//                           //   `upload/` +
//                           //   confirmPayment?.confirmPayment?.files?.path
//                           // }`}
//                         />
//                       )
//                     )
//                   )} */}
//                       <CardMedia
//                         component="img"
//                         height="140"
//                         image={`${baseUrl + `upload/` + v?.files[0]?.path}`}
//                         alt="green iguana"
//                         // src={`${
//                         //   baseUrl +
//                         //   `upload/` +
//                         //   confirmPayment?.confirmPayment?.files?.path
//                         // }`}
//                       />
//                       <CardContent>
//                         <Typography
//                           sx={{
//                             color: "black",

//                             textTransform: "capitalize",
//                           }}
//                           gutterBottom
//                           variant="h5"
//                           component="div"
//                         >
//                           {v?.categories}
//                         </Typography>
//                         <Typography
//                           sx={{
//                             color: "black",
//                             fontSize: 16,
//                             textTransform: "capitalize",
//                           }}
//                           variant="body2"
//                           color="text.secondary"
//                         >
//                           {v?.job_description}
//                         </Typography>{" "}
//                         <Typography
//                           variant="body2"
//                           sx={{ py: 2 }}
//                           color="text.secondary"
//                         >
//                           Date Posted:{" "}
//                           <Typography
//                             sx={{
//                               color: "black",
//                             }}
//                             variant="span"
//                           >
//                             {v?.dateCreated}
//                           </Typography>
//                         </Typography>{" "}
//                         <Typography variant="body2" color="text.secondary">
//                           posted By:
//                           <Typography
//                             sx={{
//                               color: "black",
//                               fontSize: 20,
//                               textTransform: "capitalize",
//                             }}
//                             variant="span"
//                           >
//                             {/* {zipCodeResult?.dateCreated} */} {"babat"}
//                           </Typography>
//                         </Typography>
//                       </CardContent>
//                       <CardActions>
//                         <Button size="small">Share</Button>
//                         <Button size="small">Learn More</Button>
//                       </CardActions>
//                     </Card>{" "}
//                     {/* <Item>3</Item> */}
//                   </Grid>
//                 </>
//               ))
//             : AllResult.length === 2
//             ? AllResult?.map((v, i) => (
//                 <>
//                   <Grid
//                     key={v._id}
//                     className="lg:w-[50%] md:pb-5 md:w-[50%]  sm:w-2/4"
//                     sx={[
//                       { px: 3 },
//                       (theme) => ({
//                         [theme.breakpoints.down("sm")]: {
//                           width: "90%",
//                           py: 3,
//                           mx: 3,
//                         },
//                       }),
//                     ]}
//                   >
//                     <Card sx={{ maxWidth: "100%" }}>
//                       {/* {v.files?.map(
//                     (file) => (
//                       console.log({ file }),
//                       (
//                         <CardMedia
//                           component="img"
//                           height="140"
//                           image={`${baseUrl + `upload/` + file?.path}`}

//                           alt="green iguana"
//                           // src={`${
//                           //   baseUrl +
//                           //   `upload/` +
//                           //   confirmPayment?.confirmPayment?.files?.path
//                           // }`}
//                         />
//                       )
//                     )
//                   )} */}
//                       <CardMedia
//                         component="img"
//                         height="140"
//                         image={`${baseUrl + `upload/` + v?.files[0]?.path}`}
//                         alt="green iguana"
//                         // src={`${
//                         //   baseUrl +
//                         //   `upload/` +
//                         //   confirmPayment?.confirmPayment?.files?.path
//                         // }`}
//                       />
//                       <CardContent>
//                         <Typography
//                           sx={{
//                             color: "black",

//                             textTransform: "capitalize",
//                           }}
//                           gutterBottom
//                           variant="h5"
//                           component="div"
//                         >
//                           {v?.categories}
//                         </Typography>
//                         <Typography
//                           sx={{
//                             color: "black",
//                             fontSize: 16,
//                             textTransform: "capitalize",
//                           }}
//                           variant="body2"
//                           color="text.secondary"
//                         >
//                           {v?.job_description}
//                         </Typography>{" "}
//                         <Typography
//                           variant="body2"
//                           sx={{ py: 2 }}
//                           color="text.secondary"
//                         >
//                           Date Posted:{" "}
//                           <Typography
//                             sx={{
//                               color: "black",
//                             }}
//                             variant="span"
//                           >
//                             {v?.dateCreated}
//                           </Typography>
//                         </Typography>{" "}
//                         <Typography variant="body2" color="text.secondary">
//                           posted By:
//                           <Typography
//                             sx={{
//                               color: "black",
//                               fontSize: 20,
//                               textTransform: "capitalize",
//                             }}
//                             variant="span"
//                           >
//                             {/* {zipCodeResult?.dateCreated} */} {"babat"}
//                           </Typography>
//                         </Typography>
//                       </CardContent>
//                       <CardActions>
//                         {/* <Link to={"/check"}>learnmore</Link>
//                           <Button size="small">Share</Button> */}
//                         <Button size="small">
//                           {" "}
//                           <Link to={"/check"}>Learn More</Link>e
//                         </Button>
//                         <TransitionsModal singleJob={v} />
//                       </CardActions>
//                     </Card>{" "}
//                     {/* <Item>3</Item> */}
//                   </Grid>
//                 </>
//               ))
//             : AllResult?.map((v, i) => (
//                 <>
//                   <Grid
//                     key={v._id}
//                     className="lg:w-[30%] md:pb-5 md:w-[40%]  sm:w-2/4"
//                     sx={[
//                       { px: 2 },
//                       (theme) => ({
//                         [theme.breakpoints.down("sm")]: {
//                           width: "90%",
//                           py: 3,
//                           mx: 3,
//                         },
//                       }),
//                     ]}
//                   >
//                     <Card sx={{ width: "100%" }}>
//                       {/* {v.files?.map(
//                     (file) => (
//                       console.log({ file }),
//                       (
//                         <CardMedia
//                           component="img"
//                           height="140"
//                           image={`${baseUrl + `upload/` + file?.path}`}

//                           alt="green iguana"
//                           // src={`${
//                           //   baseUrl +
//                           //   `upload/` +
//                           //   confirmPayment?.confirmPayment?.files?.path
//                           // }`}
//                         />
//                       )
//                     )
//                   )} */}
//                       <CardMedia
//                         component="img"
//                         height="140"
//                         image={`${baseUrl + `upload/` + v?.files[0]?.path}`}
//                         alt="green iguana"
//                         // src={`${
//                         //   baseUrl +
//                         //   `upload/` +
//                         //   confirmPayment?.confirmPayment?.files?.path
//                         // }`}
//                       />
//                       <CardContent>
//                         <Typography
//                           sx={{
//                             color: "black",

//                             textTransform: "capitalize",
//                           }}
//                           gutterBottom
//                           variant="h5"
//                           component="div"
//                         >
//                           {v?.categories}
//                         </Typography>
//                         <Typography
//                           sx={{
//                             color: "black",
//                             fontSize: 16,
//                             textTransform: "capitalize",
//                           }}
//                           variant="body2"
//                           color="text.secondary"
//                         >
//                           {v?.job_description}
//                         </Typography>{" "}
//                         <Typography
//                           variant="body2"
//                           sx={{ py: 2 }}
//                           color="text.secondary"
//                         >
//                           Date Posted:{" "}
//                           <Typography
//                             sx={{
//                               color: "black",
//                             }}
//                             variant="span"
//                           >
//                             {v?.dateCreated}
//                           </Typography>
//                         </Typography>{" "}
//                         <Typography variant="body2" color="text.secondary">
//                           posted By:
//                           <Typography
//                             sx={{
//                               color: "black",
//                               fontSize: 20,
//                               textTransform: "capitalize",
//                             }}
//                             variant="span"
//                           >
//                             {/* {zipCodeResult?.dateCreated} */} {"babat"}
//                           </Typography>
//                         </Typography>
//                       </CardContent>
//                       <CardActions>
//                         <Button size="small">Share</Button>
//                         <Button size="small">Learn More</Button>
//                       </CardActions>
//                     </Card>{" "}
//                     {/* <Item>3</Item> */}
//                   </Grid>
//                 </>
//               ))}
//         </Grid>

//         {/* <Paper
//           sx={[
//             {
//               maxWidth: "lg",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               ml: 10,
//               my: 15,
//             },
//             (theme) => ({
//               [theme.breakpoints.down("sm")]: {
//                 py: 3,
//                 mx: 3,
//                 ml: 3,
//               },
//             }),
//           ]}
//         >
//           <Typography
//             variant="p"
//             component="p"
//             className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
//           >
//             Upgrade today to enjoy the full benefits of TOP Neigbourhood Pro's
//             Premium Membership
//           </Typography>
//           <Link to={"/dashboard/premium-plan"}>
//             <Button className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full">
//               Find out more
//             </Button>
//           </Link>
//         </Paper> */}
//       </Fade>
//     </>
//   );
// };

const SearchResult = (props) => {
  // const navigate = useNavigate();
  // const userSignIn = useSelector((state) => state?.userSignIn);
  // const { userInfo } = userSignIn;
  // console.log({ userInfo, userSignIn });

  const [searchParams, setSearchParams] = useSearchParams();
  let searcZipCode = searchParams.get("query");
  console.log({ searcZipCode }, "Number(searcZipCode)", Number(searcZipCode));
  const { data, error, isError, isSuccess, isFetching } =
    useFindJobByZipCodeApiQuery(Number(searcZipCode));

  console.log({ data });

  let AllResult;
  if (isFetching) {
    AllResult = <Loading />;
  } else if (isSuccess) {
    AllResult = data?.getAvailableJob;
  } else if (isError) {
    AllResult = Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error?.data?.message,
    });
  }

  return (
    // <Grid
    //   container
    //   item
    //   spacing={{ xs: 2, md: 4, my: 3 }}
    //   // columns={{ xs: 4, sm: 8, md: 12 }}
    // >
    //   {data?.getAvailableJob.length > 0 ? (
    //     <GetJobSearchResult AllResult={AllResult} />
    //   ) : (
    //     <p className="py-4 text-center font-bold text-xs sm:text-base md:text-xl mx-3">
    //       No result found available
    //     </p>
    //   )}
    // </Grid>
    <Container className="md:ml-30" maxWidth="lg">
      <div className="flex  ml-10 justify-center  flex-col w-full py-20 ">
        {data?.getAvailableJob.length > 0 ? (
          <GetJobSearchResult AllResult={AllResult} />
        ) : (
          <p className="py-4 text-center font-bold text-xs sm:text-base md:text-xl mx-3">
            No result found available
          </p>
        )}
      </div>
    </Container>
  );
};

export default SearchResult;
